export default {
	getById(id, cb, ecb = null, config = {}) {
		this.http
			.get(`/sale/getById/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/sale/search', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/sale/update', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	addItem(saleid, form, cb, ecb) {
		this.http
			.post(`/sale/addItem/${saleid}`, form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	removeItem(itemid, saleid, cb, ecb) {
		this.http
			.post(`/sale/removeItem/${itemid}/${saleid}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	removeItemSKU(itemid, saleid, cb, ecb) {
		this.http
			.post(`/sale/removeItemSKU/${itemid}/${saleid}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
